import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import VuexPersistence from 'vuex-persist';
import { RootState } from '@/store/storeStateInterface';
import customerStore from '@/store/customer.store';
import settingsStore from '@/store/settings.store';
import projectStore from '@/store/project.store';
// @ts-ignore
import actuatorStore from '@/store/actuator.store';
import userStore from '@/store/user.store';
import authStore from '@/store/auth.store';
import revisionStore from '@/store/revision.store';

Vue.use(Vuex);

const vuexPersistence = new VuexPersistence({
    key: process.env.VUE_APP_TITLE,
    storage: window.localStorage,
    reducer: (state: any) => ({
        auth: {
            token: state.auth.token,
            user: state.auth.user,
            lastUsername: state.auth.lastUsername
        },
        settings: {
            customer: state.settings.customer,
            project: state.settings.project,
            actuator: state.settings.actuator,
            revision: state.settings.revision
        },
        user: {
            allUsers: state.user.allUsers
        }
    })
});

const store: StoreOptions<RootState> = {
    modules: {
        customer: {
            namespaced: true,
            ...customerStore
        },
        project: {
            namespaced: true,
            ...projectStore
        },
        settings: {
            namespaced: true,
            ...settingsStore
        },
        actuator: {
            namespaced: true,
            ...actuatorStore
        },
        user: {
            namespaced: true,
            ...userStore
        },
        auth: {
            namespaced: true,
            ...authStore
        },
        revision: {
            namespaced: true,
            ...revisionStore
        }
    },
    plugins: [vuexPersistence.plugin]
};

export default new Vuex.Store<RootState>(store);
